import React from 'react';
import './switch.css';

interface ISwitchProps {
  checked: boolean;
  setChecked: () => void;
  cy: string;
}

export const Switch = ({
  checked,
  setChecked,
  cy,
}: ISwitchProps): JSX.Element => {
  return (
    <label className="switch-component">
      <input
        type="checkbox"
        checked={checked}
        onChange={setChecked}
        data-cy={`Switch${cy}`}
      />
      <span className="slider-component round"></span>
    </label>
  );
};
